export default __webpack_public_path__ + "static/media/diagnostic.b23182af.svg";